const MuiSkeleton = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: `${theme.palette.primary.light}60`,
    }),
  },
  defaultProps: {
    animation: "wave",
  },
};

export default MuiSkeleton;
